import i18n from './language.service'
const { t } = i18n

export const setPageTitle = (pathname: string) => {
  switch (pathname) {
    case '/':
      document.title = 'ATCP App - Home'
      break
    case '/contracts':
      document.title = 'ATCP App - Contract List'
      break
    case '/contracts/add-contract':
      document.title = 'ATCP App - Add Contract'
      break
    case '/repairs-and-inquiries':
      document.title = 'ATCP App - Repair And Inquiries'
      break
    case '/repairs-and-inquiries/new-request':
      document.title = 'ATCP App - Repair And Inquiries Request'
      break
    case '/account':
      document.title = 'ATCP App - Account'
      break
    case '/account/edit-theme':
      document.title = 'ATCP App - Edit Theme'
      break
    case '/imprint':
      document.title = 'ATCP App - Imprint'
      break
    case '/privacy-policy':
      document.title = 'ATCP App - Privacy And Policy'
      break
    default:
      document.title = 'ATCP App'
  }
}

export const setPageHeader = (pathname: string) => {
  let pageHeading = ''
  let headingHeader = ''
  let redirectLink = ''

  switch (pathname) {
    case '/login':
    case '/register':
    case '/':
      pageHeading = 'home'
      break
    case '/repairs-and-inquiries':
      pageHeading = 'repairs_and_inquiries'
      break
    case '/repairs-and-inquiries/new-request':
      headingHeader = t('NAVBAR.NEW_REQUEST')
      redirectLink = '/repairs-and-inquiries'
      break
    case '/contracts':
      pageHeading = 'contracts'
      break
    case '/contracts/add-contract':
      headingHeader = t('NAVBAR.ADD_CONTRACT')
      redirectLink = '/contracts'
      break
    case '/account':
      pageHeading = 'account'
      break
    case '/account/edit-theme':
      headingHeader = t('NAVBAR.EDIT_THEME')
      redirectLink = '/account'
      break
    default:
      headingHeader = ''
      redirectLink = ''
      pageHeading = ''
  }

  return { pageHeading, headingHeader, redirectLink }
}
